import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider, createTheme, GlobalStyles } from '@mui/material';

export const AppTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#00446a',
      light: '#406f98',
      dark: '#001e3f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f08b1d',
      light: '#ffbc51',
      dark: '#b85d00',
      contrastText: '#000000',
    },
    background: {
      default: '#E1E2E1',
      paper: '#F5F5F6',
    },
  },
});

const globalStyles = {
  '*::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5',
  },
  '*::-webkit-scrollbar': {
    width: 6,
    height: 6,
    backgroundColor: '#F5F5F5',
  },
  '*::-webkit-scrollbar-thumb': {
    borderRadius: 20,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: `${AppTheme.palette.secondary.main}`,
  },
};

export const AppThemeProvider: React.FunctionComponent<{}> = React.memo(({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={AppTheme}>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
});
